<ul class="primary-nav__menu">
  <li class="primary-nav__menu-item">
    <a
      routerLink="/receipts"
      attr.aria-label="{{ 'RECEIVE_GOODS' | translate | capitalize }}"
      routerLinkActive="primary-nav__link--active"
      class="d-flex w-100 align-items-center justify-content-between primary-nav__link">
      <div>
        <div class="primary-nav__link">
          <i class="rc-icon-transfer-in"></i>
          <span class="primary-nav__link--text">{{ "RECEIVE_GOODS" | translate | capitalize }}</span>
        </div>
      </div>
      <div>
        <i class="rc-icon-chevron-right"></i>
      </div>
    </a>
  </li>
  <li class="primary-nav__menu-item">
    <a
      routerLink="/client_returns"
      attr.aria-label="{{ 'RECEIVE_RETURN' | translate | capitalize }}"
      routerLinkActive="primary-nav__link--active"
      class="d-flex w-100 align-items-center justify-content-between primary-nav__link">
      <div>
        <div class="primary-nav__link">
          <i class="rc-icon-return"></i>
          <span class="primary-nav__link--text">{{ "RECEIVE_RETURN" | translate | capitalize }}</span>
        </div>
      </div>
      <div>
        <i class="rc-icon-chevron-right"></i>
      </div>
    </a>
  </li>
  <li class="primary-nav__menu-item">
    <a
      routerLink="/link_serial_numbers"
      attr.aria-label="{{ 'LINK_SERIAL_NUMBERS' | translate | capitalize }}"
      routerLinkActive="primary-nav__link--active"
      class="d-flex w-100 align-items-center justify-content-between primary-nav__link">
      <div>
        <div class="primary-nav__link">
          <i class="rc-icon-barcode"></i>
          <span class="primary-nav__link--text">{{ "LINK_SERIAL_NUMBERS" | translate | capitalize }}</span>
        </div>
      </div>
      <div>
        <i class="rc-icon-chevron-right"></i>
      </div>
    </a>
  </li>
  <li class="primary-nav__menu-item">
    <a
      class="d-flex w-100 align-items-center justify-content-between primary-nav__link"
      attr.aria-label="{{ 'MOVE_GOODS' | translate | capitalize }}"
      routerLinkActive="primary-nav__link--active"
      routerLink="/move_goods">
      <div>
        <div class="primary-nav__link">
          <i class="rc-icon-forklift"></i>
          <span class="primary-nav__link--text">{{ "MOVE_GOODS" | translate | capitalize }}</span>
        </div>
      </div>
      <div>
        <i class="rc-icon-chevron-right"></i>
      </div>
    </a>
  </li>
  <li class="primary-nav__menu-item">
    <a
      routerLink="/pick_orders"
      attr.aria-label="{{ 'PICK_GOODS' | translate | capitalize }}"
      routerLinkActive="primary-nav__link--active"
      class="d-flex w-100 align-items-center justify-content-between primary-nav__link">
      <div>
        <div class="primary-nav__link">
          <i class="rc-icon-pick-order"></i>
          <span class="primary-nav__link--text">{{ "PICK_GOODS" | translate | capitalize }}</span>
        </div>
      </div>
      <div>
        <i class="rc-icon-chevron-right"></i>
      </div>
    </a>
  </li>
  <li class="primary-nav__menu-item">
    <a
      routerLink="/delivery_notes"
      attr.aria-label="{{ 'DELIVERY_NOTES' | translate | capitalize }}"
      routerLinkActive="primary-nav__link--active"
      class="d-flex w-100 align-items-center justify-content-between primary-nav__link">
      <div>
        <div class="primary-nav__link">
          <i class="rc-icon-file-text"></i>
          <span class="primary-nav__link--text">{{ "DELIVERY_NOTES" | translate | capitalize }}</span>
        </div>
      </div>
      <div>
        <i class="rc-icon-chevron-right"></i>
      </div>
    </a>
  </li>
  <li class="primary-nav__menu-item">
    <a
      routerLink="/deliveries"
      class="d-flex w-100 align-items-center justify-content-between primary-nav__link"
      attr.aria-label="{{ 'SEND_GOODS' | translate | capitalize }}"
      routerLinkActive="primary-nav__link--active">
      <div>
        <div class="primary-nav__link">
          <i class="rc-icon-transfer-out"></i>
          <span class="primary-nav__link--text">{{ "SEND_GOODS" | translate | capitalize }}</span>
        </div>
      </div>
      <div>
        <i class="rc-icon-chevron-right"></i>
      </div>
    </a>
  </li>
  <li class="primary-nav__menu-item">
    <a
      routerLink="/sign_delivery_note"
      class="d-flex w-100 align-items-center justify-content-between primary-nav__link"
      attr.aria-label="{{ 'SIGN_DELIVERY_NOTE' | translate | capitalize }}"
      routerLinkActive="primary-nav__link--active">
      <div>
        <div class="primary-nav__link">
          <i class="rc-icon-handover"></i>
          <span class="primary-nav__link--text">{{ "SIGN_DELIVERY_NOTE" | translate | capitalize }}</span>
        </div>
      </div>
      <div>
        <i class="rc-icon-chevron-right"></i>
      </div>
    </a>
  </li>
  <li class="primary-nav__menu-item">
    <a
      routerLink="/undo_pick_orders"
      attr.aria-label="{{ 'UNDO_PICKING' | translate | capitalize }}"
      routerLinkActive="primary-nav__link--active"
      class="d-flex w-100 align-items-center justify-content-between primary-nav__link">
      <div>
        <div class="primary-nav__link">
          <i class="rc-icon-revert-picking"></i>
          <span class="primary-nav__link--text">{{ "UNDO_PICKING" | translate | capitalize }}</span>
        </div>
      </div>
      <div>
        <i class="rc-icon-chevron-right"></i>
      </div>
    </a>
  </li>
  <li class="primary-nav__menu-item">
    <a
      routerLink="/stock_corrections"
      attr.aria-label="{{ 'STOCK_CORRECTIONS' | translate | capitalize }}"
      routerLinkActive="primary-nav__link--active"
      class="d-flex w-100 align-items-center justify-content-between primary-nav__link">
      <div>
        <div class="primary-nav__link">
          <i class="rc-icon-package-plus"></i>
          <span class="primary-nav__link--text">{{ "EXECUTE_STOCK_CORRECTION" | translate | capitalize }}</span>
        </div>
      </div>
      <div>
        <i class="rc-icon-chevron-right"></i>
      </div>
    </a>
  </li>
  <li class="primary-nav__menu-item">
    <a
      routerLink="/stock_locations"
      class="d-flex w-100 align-items-center justify-content-between primary-nav__link"
      attr.aria-label="{{ 'VIEW_LOCATION' | translate | capitalize }}"
      routerLinkActive="primary-nav__link--active">
      <div>
        <div class="primary-nav__link">
          <i class="rc-icon-location-info"></i>
          <span class="primary-nav__link--text">{{ "VIEW_LOCATION" | translate | capitalize }}</span>
        </div>
      </div>
      <div>
        <i class="rc-icon-chevron-right"></i>
      </div>
    </a>
  </li>
  <li class="primary-nav__menu-item">
    <a
      routerLink="/stock_items"
      attr.aria-label="{{ 'ARTICLE_INFO' | translate | capitalize }}"
      routerLinkActive="primary-nav__link--active"
      class="d-flex w-100 align-items-center justify-content-between primary-nav__link">
      <div>
        <div class="primary-nav__link">
          <i class="rc-icon-microwave"></i>
          <span class="primary-nav__link--text">{{ "ARTICLE_INFO" | translate | capitalize }}</span>
        </div>
      </div>
      <div>
        <i class="rc-icon-chevron-right"></i>
      </div>
    </a>
  </li>
</ul>
